module.exports = __webpack_public_path__ + "static/media/profile_pic.7b42f90d.png";